import { ComponentType } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { compose } from 'redux';
import { withSizes } from 'react-sizes';

import { fetchPublicationsPage } from 'client/ducks/publications/actions';
import { fetchTheme, fetchThemes } from 'client/ducks/themes/actions';
import {
    isLoading,
    hasMorePublications,
    getPublications,
    getPublicationsMeta,
    getPageParams
} from 'client/ducks/publications/selectors';
import {
    getTheme,
    getThemes,
    isLoading as isLoadingTheme,
    isLoading as isLoadingThemes
} from 'client/ducks/themes/selectors';
import { State } from 'client/store';

import PublicationsListPage, { DispatchProps, StateProps } from './publication-list';
import { mapSizesToProps } from 'client/helpers/sizes';

function mapStateToProps(state: State): StateProps {
    return {
        hasMore: hasMorePublications(state),
        rows: getPublications(state),
        meta: getPublicationsMeta(state),
        theme: getTheme(state),
        themes: getThemes(state),
        isLoading: isLoading(state),
        params: getPageParams(state),
        isLoadingTheme: isLoadingTheme(state),
        isLoadingThemes: isLoadingThemes(state)
    };
}

const mapDispatchToProps = ({
    fetchPage: fetchPublicationsPage,
    fetchTheme,
    fetchThemes
});

const component = compose<ComponentType>(
    connect<StateProps, DispatchProps>(mapStateToProps, mapDispatchToProps),
    withRouter,
    withSizes(mapSizesToProps)
)(PublicationsListPage) as any;

component.asyncFetchData = PublicationsListPage.asyncFetchData;

export default component;
